import CartAnimActionTypes from "./cart-anim.types";

export const setAnimStart = () => ({
  type: CartAnimActionTypes.CART_ANIM_START,
});

export const setAnimEnd = () => ({
  type: CartAnimActionTypes.CART_ANIM_END,
});
